"use client";
import { jsx as c, jsxs as v } from "react/jsx-runtime";
import { c as d } from "../../tslib.es6-CkJbB1D2.mjs";
import { useState as h, useEffect as b } from "react";
import { LegacyButton as S } from "@zapier/design-system";
import { emitUserInteractionEvent as C } from "../../observability/tracking/emitEvent.es.js";
import { UserInteractionEventName as U } from "../../observability/tracking/trackingTypes.es.js";
import { useLocalStorage as w } from "../../hooks/useLocalStorage.es.js";
import { LOCALSTORAGE_TEMPLATE_CREATE_KEY as E } from "../../constants/constants.es.js";
import { GoogleLogoSvg as _ } from "./GoogleLogoSvg.es.js";
const L = "_buttonWrapper_wpbvq_1", k = "_buttonContent_wpbvq_9", m = {
  buttonWrapper: L,
  buttonContent: k
};
var x = function(t) {
  var n = t.baseUrl, a = t.search, r = t.pathname, e = new URL("/google-sso/start", n);
  e.searchParams.set("scopes", "basic");
  var o = r;
  return a ? o += "".concat(a, "&create=true") : o += "?create=true", e.searchParams.set("next", o), e.toString();
}, N = function(t) {
  var n = t.onClick, a = t.children, r = t.slug, e = t.size, o = e === void 0 ? "medium" : e, p = d(t, ["onClick", "children", "slug", "size"]), u = w(E).setValue, l = h(), i = l[0], f = l[1];
  b(function() {
    var s = x({
      baseUrl: window.location.origin,
      pathname: "/templates/details/".concat(r),
      search: window.location.search
    });
    f(s);
  }, [r]);
  var g = function(s) {
    s.preventDefault(), C(U.googleSSOButtonClicked, {
      event_action: "click",
      option_selected: ""
    }), u(r), n && n(s), i && window.location.assign(i);
  };
  return /* @__PURE__ */ c("div", { className: m.buttonWrapper, children: /* @__PURE__ */ c(S, { size: o, color: "tertiary", href: i, onClick: g, ...p, children: /* @__PURE__ */ v("span", { className: m.buttonContent, children: [
    /* @__PURE__ */ c(_, {}),
    a
  ] }) }) });
};
export {
  N as GoogleSSOButton
};
//# sourceMappingURL=GoogleSSOButton.es.js.map
